// removed by extract-text-webpack-plugin
module.exports = {"scope":"Scope__scope___DdOXZ","input":"Scope__input___2KSNa","label":"Scope__label___3ptgA","label-checked":"Scope__label-checked___1T_jU Scope__label___3ptgA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Scope/Scope.scss
// module id = 522
// module chunks = 0